import React from 'react';
import classNames from 'classnames';

type StatusType = 'success' | 'failure';

interface StatusCardProps {
  status: StatusType;
  icon: React.ReactNode;
  title?: React.ReactNode;
  header?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}

const COLOR_MAP: Record<StatusType, string> = {
  success: 'bg-success-default',
  failure: 'bg-danger-default',
};

const VAR_MAP: Record<StatusType, string> = {
  success: '--color-success-default',
  failure: '--color-danger-default',
};

const StatusCard: React.FC<StatusCardProps> = ({
  status,
  icon,
  title,
  header,
  description,
  className,
}) => {
  const colorClass = COLOR_MAP[status];
  const colorVar = VAR_MAP[status];

  const outerCircleStyle = React.useMemo(() => ({
    backgroundColor: `color-mix(in srgb, var(${colorVar}), transparent 80%)`,
  }), [colorVar]);

  return (
    <div className={classNames(
      'flex flex-col justify-center items-center w-80 h-112 p-6 bg-white/95 rounded-xl gap-7',
      className,
    )}
    >
      {header && (
        <div className="text-center text-default text-2xl font-extrabold">
          {header}
        </div>
      )}
      <div
        className="flex justify-center items-center size-36 rounded-full"
        style={outerCircleStyle}
      >
        <div className={classNames('flex items-center justify-center size-24 rounded-full', colorClass)}>
          {icon}
        </div>
      </div>
      {title && (
        <div className="text-center text-default text-lg font-bold">
          {title}
        </div>
      )}
      {description && (
        <span className="text-center text-lg text-lowest font-medium">
          {description}
        </span>
      )}
    </div>
  );
};

export default StatusCard;